import { EmailData } from './email-viewer-types';
import { Card, CardContent } from '@/components/ui/card';

const labelledPropContainerStyle = 'flex gap-1';

export function EmailHeader({ emailData }: { emailData: EmailData }) {
  return (
    <Card>
      <CardContent className="text-base space-y-1">
        {/* Subject */}
        <div className={labelledPropContainerStyle}>
          <div className="font-semibold text-gray-600">Subject:</div>
          <div className="text-gray-900 break-words">{emailData.subject}</div>
        </div>

        <div className={labelledPropContainerStyle}>
          <div className="font-semibold text-gray-600">From:</div>
          <div className="text-gray-900 break-words">{emailData.from}</div>
        </div>

        <div className={labelledPropContainerStyle}>
          <div className="font-semibold text-gray-600">To:</div>
          <div className="text-gray-900 break-words">{emailData.to}</div>
        </div>

        {/* CC - conditional */}
        {emailData.cc && (
          <div className={labelledPropContainerStyle}>
            <div className="font-semibold text-gray-600">CC:</div>
            <div className="text-gray-900 break-words">{emailData.cc}</div>
          </div>
        )}

        {/* Date - conditional */}
        {emailData.date && (
          <div className={labelledPropContainerStyle}>
            <div className="font-semibold text-gray-600">Date:</div>
            <div className="text-gray-900 break-words">
              {new Date(emailData.date).toLocaleString()}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
